import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import {I18nextProvider} from "react-i18next";
import i18n from "./i18n"; // Import the i18n configuration file
import App from "./App";
import {AppProvider} from "./context/AppContext";
import {DebugProvider} from "./context/DebugContext";

const root = ReactDOM.createRoot(document.getElementById("root"));

window.onbeforeunload = function () {
    return 'Are you sure you want to leave?';
};

root.render(
    <I18nextProvider i18n={i18n}>
        <DebugProvider>
            <AppProvider>
                <App/>
            </AppProvider>
        </DebugProvider>
    </I18nextProvider>
);
